<template>
  <div class="tab-container">
    <b-tabs type="is-boxed" size="is-small">
      <b-tab-item>
        <template slot="header" class="header">
            <span class="mdi mdi-account-edit mdi-24px" style="margin-left:8px;"></span>
            <span> 応募情報 </span>
        </template>
        <div class="flex block-container disp-scroll" style="padding-left: 36px;">
          <p style="padding: 8px;"></p>
          <p style="text-align: left;"><b>求人ページや、ロボの応募フォームに入れたい項目を設定できます。</b></p>
          <div class="tab-box-form">
            <div class="tab-box-left">
              <p style="text-align: left;"><b>お名前</b></p>
            </div>
            <div class="tab-box-right" style="justify-content: center;">
              <div style="width: 100%; display: flex; margin: 4px;">
                この項目は必ず必須入力になります。
              </div>
            </div>
            <div class="dot-line"></div>
            <div class="tab-box-left">
              <p style="text-align: left;"><b>フリガナ</b></p>
            </div>
            <div class="tab-box-right" style="justify-content: center;">
              <div style="width: 100%; display: flex; margin: 4px;">
                <b-switch id="CS-0001" style="width: 40%;" size="is-small" v-model="user.subscribe_is_name_phonetic">切替</b-switch>
                <b-switch id="CS-0002" style="width: 60%;" size="is-small" v-model="user.subscribe_required_name_phonetic" v-bind:disabled="user.subscribe_is_name_phonetic==false">
                  {{ getRequiredFlg(user.subscribe_required_name_phonetic) }}入力
                </b-switch>
              </div>
            </div>
            <div class="dot-line"></div>
            <div class="tab-box-left">
              <p style="text-align: left;"><b>性別</b></p>
            </div>
            <div class="tab-box-right" style="justify-content: center;">
              <div style="width: 100%; display: flex; margin: 4px;">
                <b-switch id="CS-0003" style="width: 40%;" size="is-small" v-model="user.subscribe_is_sex">切替</b-switch>
                <b-switch id="CS-0004" style="width: 60%;" size="is-small" v-model="user.subscribe_required_sex" v-bind:disabled="user.subscribe_is_sex==false">
                  {{ getRequiredFlg(user.subscribe_required_sex) }}入力
                </b-switch>
              </div>
            </div>
            <div class="dot-line"></div>
            <div class="tab-box-left">
              <p style="text-align: left;"><b>Email</b></p>
            </div>
            <div class="tab-box-right" style="justify-content: center;">
              <div style="width: 100%; display: flex; margin: 4px;">
                この項目は必ず必須入力になります。
                <!-- <b-switch id="CS-0005" style="width: 40%;" size="is-small" v-model="user.subscribe_is_email">切替</b-switch>
                <b-switch id="CS-0006" style="width: 60%;" size="is-small" v-model="user.subscribe_required_email" v-bind:disabled="user.subscribe_is_email==false">
                  {{ getRequiredFlg(user.subscribe_required_email) }}入力
                </b-switch> -->
              </div>
            </div>
            <div class="dot-line"></div>
            <div class="tab-box-left">
              <p style="text-align: left;"><b>TEL</b></p>
            </div>
            <div class="tab-box-right" style="justify-content: center;">
              <div style="width: 100%; display: flex; margin: 4px;">
                この項目は必ず必須入力になります。
                <!-- <b-switch id="CS-0007" style="width: 40%;" size="is-small" v-model="user.subscribe_is_tel">切替</b-switch>
                <b-switch id="CS-0008" style="width: 60%;" size="is-small" v-model="user.subscribe_required_tel" v-bind:disabled="user.subscribe_is_tel==false">
                  {{ getRequiredFlg(user.subscribe_required_tel) }}入力
                </b-switch> -->
              </div>
            </div>
            <div class="dot-line"></div>
            <div class="tab-box-left">
              <p style="text-align: left;"><b>生年月日</b></p>
            </div>
            <div class="tab-box-right" style="justify-content: center;">
              <div style="width: 100%; display: flex; margin: 4px;">
                <b-switch id="CS-0009" style="width: 40%;" size="is-small" v-model="user.subscribe_is_birth">切替</b-switch>
                <b-switch id="CS-0010" style="width: 60%;" size="is-small" v-model="user.subscribe_required_birth" v-bind:disabled="user.subscribe_is_birth==false">
                  {{ getRequiredFlg(user.subscribe_required_birth) }}入力
                </b-switch>
              </div>
            </div>
            <div class="dot-line"></div>
            <div class="tab-box-left">
              <p style="text-align: left;"><b>住所</b></p>
            </div>
            <div class="tab-box-right" style="justify-content: center;">
              <div style="width: 100%; display: flex; margin: 4px;">
                <b-switch id="CS-0011" style="width: 40%;" size="is-small" v-model="user.subscribe_is_address">切替</b-switch>
                <b-switch id="CS-0012" style="width: 60%;" size="is-small" v-model="user.subscribe_required_address" v-bind:disabled="user.subscribe_is_address==false">
                  {{ getRequiredFlg(user.subscribe_required_address) }}入力
                </b-switch>
              </div>
            </div>
            <div class="dot-line"></div>
            <div class="tab-box-left">
              <p style="text-align: left;"><b>連携ID</b></p>
            </div>
            <div class="tab-box-right" style="justify-content: center;">
              <div style="width: 100%; display: flex; margin: 4px;">
                <b-switch id="CS-0013" style="width: 40%;" size="is-small" v-model="user.subscribe_is_job_offer_no">切替</b-switch>
              </div>
            </div>
            <div class="dot-line"></div>
            <div class="tab-box-left">
              <p style="text-align: left;"><b>備考</b></p>
            </div>
            <div class="tab-box-right" style="justify-content: center;">
              <div style="width: 100%; display: flex; margin: 4px;">
                <b-switch id="CS-0014" style="width: 40%;" size="is-small" v-model="user.subscribe_is_message">切替</b-switch>
                <b-switch id="CS-0015" style="width: 60%;" size="is-small" v-model="user.subscribe_required_message" v-bind:disabled="user.subscribe_is_message==false">
                  {{ getRequiredFlg(user.subscribe_required_message) }}入力
                </b-switch>
              </div>
              <hr>
              <div style="width: 100%; display: flex; margin: 8px;" v-for="(l, idx) in user.subscribe_list_message.msg_list" :key="idx">
                <input style="width: calc(100% - 30px);" class="input is-small" v-model="user.subscribe_list_message.msg_list[idx]"/>
                <button style="width: 30px;" class="button is-small is-danger" @click="user.subscribe_list_message.msg_list.splice(idx, 1)" v-if="user.subscribe_list_message.msg_list.length > 1">×</button>
              </div>
              <button id="CS-0016" class="button is-small is-fullwidth" @click="user.subscribe_list_message.msg_list.push(['質問をしたい'])" v-if="user.subscribe_list_message.msg_list.length <= 20">+ 追加</button>
            </div>
            <div class="dot-line"></div>
            <a class="button is-primary is-fullwidth" @click="setProfile(
              {
                'subscribe_is_name'          : true,
                // 'subscribe_is_email'         : user.subscribe_is_email,
                'subscribe_is_email'         : true,
                // 'subscribe_is_tel'           : user.subscribe_is_tel,
                'subscribe_is_tel'           : true,
                'subscribe_is_name_phonetic' : user.subscribe_is_name_phonetic,
                'subscribe_is_job_offer_no'  : user.subscribe_is_job_offer_no,
                'subscribe_is_sex'           : user.subscribe_is_sex,
                'subscribe_is_birth'         : user.subscribe_is_birth,
                'subscribe_is_address'       : user.subscribe_is_address,
                'subscribe_is_message'       : user.subscribe_is_message,
                'subscribe_list_message'     : user.subscribe_list_message,
                'subscribe_required_name'    : true,
                // 'subscribe_required_email'         : user.subscribe_required_email,
                'subscribe_required_email'         : true,
                // 'subscribe_required_tel'           : user.subscribe_required_tel,
                'subscribe_required_tel'           : true,
                'subscribe_required_name_phonetic' : user.subscribe_required_name_phonetic,
                'subscribe_required_sex'           : user.subscribe_required_sex,
                'subscribe_required_birth'         : user.subscribe_required_birth,
                'subscribe_required_address'       : user.subscribe_required_address,
                'subscribe_required_message'       : user.subscribe_required_message,
              }
              , 'company'
            )" v-if="user.permission===0">変更する</a>
            <a class="button is-primary is-fullwidth" v-if="user.permission!==0" disabled>変更する</a>
          </div>
        </div>
      </b-tab-item>
      <b-tab-item>
        <template slot="header" class="header">
            <span class="mdi mdi-account-edit mdi-24px" style="margin-left:8px;"></span>
            <span> 応募メール </span>
        </template>
        <div class="flex block-container disp-scroll" style="padding-left: 36px; max-width: 100%;">
          <p style="padding: 8px;"></p>
          <p style="text-align: left;"><b>応募用のメールを設定できます。</b></p>
          <div class="tab-box-form" style="max-width: 100%;">
            <div class="tab-box-left" style="padding: 8px;">
              <div>
                <p style="text-align: left;"><b>応募メール内容</b></p>
                <p style="text-align: left;">
                  ロボの応募フォームから登録があった場合に本内容を送付いたします。<br>
                  __applicant__    : 応募者名<br>
                  __tel__          : 応募者電話番号<br>
                  __email__        : 応募者Email<br>
                  __company_name__ : 会社名<br>
                  __recieved_form__ : 返信フォームリンク<br>
                </p>
              </div>
            </div>
            <div class="tab-box-right disp-scroll" style="justify-content: center; padding: 8px;">
              <quill-editor
                v-model="user.mail_content"
                ref="quillEditor"
                :options="options">
              </quill-editor>
            </div>
            <div class="dot-line"></div>
            <div class="tab-box-left" style="padding: 8px;">
              <div>
                <p style="text-align: left;"><b>署名</b></p>
                <p style="text-align: left;">
                  メールの最後に付与されます。初回応募の方にはメール内容と署名の間に登録用のリンクを送付しております。
                </p>
              </div>
            </div>
            <div class="tab-box-right disp-scroll" style="justify-content: center; padding: 8px;">
              <quill-editor
                v-model="user.mail_sign"
                ref="quillEditor"
                :options="options">
              </quill-editor>
            </div>
            <div class="dot-line"></div>
            <a class="button is-primary is-fullwidth" style="margin-top: 48px;" @click="setProfile(
              {
                'mail_content' : user.mail_content,
                'mail_sign'    : user.mail_sign,
              }
              , 'company'
            )" v-if="user.permission===0">変更する</a>
            <a class="button is-primary is-fullwidth" v-if="user.permission!==0" disabled>変更する</a>
          </div>
        </div>
      </b-tab-item>
      <b-tab-item>
        <template slot="header" class="header">
            <span class="mdi mdi-email-outline mdi-24px" style="margin-left:5px;"></span>
            <span>スカウト設定</span>
        </template>
        <div class="block-container disp-scroll" style="text-align: left; width: 90%; margin: auto; margin-top: 40px;">
          <h1>基本設定</h1>
          <div class="tab-box-form" style="padding: 0;">
            <div class="tab-box-left">
              <p style="text-align: left;">スカウト送付機能</p>
            </div>
            <div class="tab-box-right" style="justify-content: center;">
              <b-switch id="CS-0017" v-model="user.scout_flg" style="width: 100%;" size="is-small">OFF/ON</b-switch>
            </div>
          </div>
          <div style="margin-top: 16px;">
            <p>スカウト文</p>
            <textarea v-model="user.scout_message" class="textarea disp-scroll"></textarea>
          </div>
          <h1 style="margin-top: 40px;">スカウトメール設定</h1>
          <div>
            <p>件名</p>
            <input v-model="user.scout_mail_title" class="input">
          </div>
          <div style="margin-top: 16px;">
            <p>内容</p>
            <quill-editor v-model="user.scout_mail_message" ref="quillEditor" :options="options"></quill-editor>
          </div>
          <div style="margin: 40px;">
            <button @click="setProfile({
              'scout_flg': user.scout_flg,
              'scout_message': user.scout_message,
              'scout_mail_title': user.scout_mail_title,
              'scout_mail_message': user.scout_mail_message
            }, 'company')" class="button is-primary is-fullwidth">変更する</button>
          </div>
        </div>
      </b-tab-item>
    </b-tabs>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import hex2rgb from '@/functions/hex2rgb'
import controlLogMixin from '@/mixins/controlLogMixin'
export default {
  name: 'CommonSetting',
  componentName: 'CommonSetting',
  mixins: [
    controlLogMixin
  ],
  data () {
    return {
      isUploaded: false,
      filename: '',
      uploadedImage: '',
      file: null,
      isCommonPage: true,
      isFavoritePage: false,
      selectedType: [],
      selectedNum: [],
      buttonMD: [],
      buttonCL: [],
      buttonColors: [
        'White',
        'Blue',
        'Yellow',
        'Red'
      ],
      fvList1: [],
      fvList2: [],
      fvList3: [],
      iconName: [
        'アイコン１',
        'アイコン２',
        'アイコン３',
        'アイコン４',
        'アイコン５',
        'アイコン６',
        'アイコン７',
        'アイコン８',
        'アイコン９',
        'アイコン１０',
        '画像'
      ],
      shapeName: [
        '四角',
        '丸'
      ],
      shadowName: [
        'なし',
        'あり'
      ],
      inputName: [
        'なし',
        'あり'
      ],
      headerName: [
        'なし',
        'あり'
      ],
      viewTemplate: 0,
      viewList: [
        'アイコン一覧表現',
        'カード表現',
        '選択表現なし'
      ],
      options: {
        theme: 'snow',
        placeholder: '内容を入力...',
      },
    }
  },
  computed: {
    ...mapState('auth', ['user', 'snippets', 'color', 'success', 'error', 'power', 'isLoading', 'message']),
    classObj: function () {
      console.debug('*** Start *** classObj')
      return {
        'mdi mdi-message-reply mdi-36px': this.color.template === 0,
        'mdi mdi-account-location mdi-36px': this.color.template === 1,
        'mdi mdi-phone mdi-36px': this.color.template === 2,
        'mdi mdi-home-circle mdi-36px': this.color.template === 3,
        'mdi mdi-bell mdi-36px': this.color.template === 4,
        'mdi mdi-forum mdi-36px': this.color.template === 5,
        'mdi mdi-forum-outline mdi-36px': this.color.template === 6,
        'mdi mdi-comment mdi-36px': this.color.template === 7,
        'mdi mdi-comment-multiple mdi-36px': this.color.template === 8,
        'mdi mdi-comment-processing mdi-36px': this.color.template === 9,
        'mdi mdi-loading mdi-spin mdi-36px': this.isLoading
      }
    }
  },
  methods: {
    isVideo () {
      return localStorage.getItem('IS_VIDEO_FLG')
    },
    setProfile (data, type) {
      this.sendControlLog('共通設定　変更', '共通設定画面にて、「変更する」ボタンをクリックした。')
      console.debug('*** Start *** setProfile')
      console.debug('data: ' + data)
      console.debug('type: ' + type)
      this.$store.dispatch('auth/setProfile', {data: data, type: type})
        .then(() => { if (this.error) { this.errorBar(this.error) } })
        .then(() => { if (!this.error) { this.successBar() } })
      console.debug('*** End *** setProfile')
    },
    errorBar (e) {
      console.debug('*** Start *** errorBar')
      console.error('e: ' + JSON.stringify(e))
      this.$buefy.snackbar.open({
        message: '正常に保存が完了しませんでした。再読み込みしてください。',
        type: 'is-danger',
        position: 'is-top'
      })
      console.debug('*** End *** errorBar')
    },
    successBar () {
      console.debug('*** Start *** successBar')
      this.$buefy.snackbar.open({
        message: 'セーブしました！',
        type: 'is-success',
        position: 'is-top'
      })
      console.debug('*** End *** successBar')
    },
    editFVCard (type, index) {
      console.debug('*** Start *** editFVCard')
      console.debug('type: ' + JSON.stringify(type))
      console.debug('index: ' + JSON.stringify(index))
      if (type === this.user.favoriteLists[0].type) this.fvList1[index].editable = true
      if (type === this.user.favoriteLists[1].type) this.fvList2[index].editable = true
      if (type === this.user.favoriteLists[2].type) this.fvList3[index].editable = true
      console.debug('*** End *** editFVCard')
    },
    makeView () {
      console.debug('*** Start *** makeView')
      return require('@/assets/template/select_0' + (this.color.view_template + 1) + '.svg')
    },
    clipcopy () {
      console.debug('*** Start *** clipcopy')
      let codeToCopy = document.querySelector('#copy-code')
      codeToCopy.setAttribute('type', 'text')
      codeToCopy.select()
      try {
        var successful = document.execCommand('copy')
        if (successful) {
          console.info('success')
          this.$buefy.toast.open({
            message: 'クリップボードにコピーしました。',
            type: 'is-success'
          })
        } else {
          console.error('error')
          this.$buefy.toast.open({
            message: 'クリップボードにコピーできませんでした。',
            type: 'is-danger'
          })
        }
      } catch (err) {
          console.error('err: ' + JSON.stringify(err))
          alert('Oops, unable to copy')
      }
      codeToCopy.setAttribute('type', 'hidden')
      window.getSelection().removeAllRanges()
      console.debug('*** End *** clipcopy')
    },
    changeColor (){
      console.debug('*** Start *** changeColor')
      this.$store.dispatch('auth/setColor', this.color)
      console.debug('*** End *** changeColor')
    },
    errorBar (e) {
      console.debug('*** Start *** errorBar')
      console.error('e: ' + JSON.stringify(e))
      this.$buefy.snackbar.open({
        message: '正常に保存が完了しませんでした。',
        type: 'is-danger',
        position: 'is-top'
      })
      console.debug('*** End *** errorBar')
    },
    successBar () {
      console.debug('*** Start *** successBar')
      this.$buefy.snackbar.open({
        message: 'セーブしました！',
        type: 'is-success',
        position: 'is-top'
      })
      console.debug('*** End *** successBar')
    },
    changeSwitch () {
      console.debug('*** Start *** changeSwitch')
      this.$store.dispatch('auth/setPower', !(this.power === 1))
      console.debug('*** End *** changeSwitch')
    },
    shapeStyle () {
      console.debug('*** Start *** shapeStyle')
      if (this.color.shapeType === 0) return '15px'
      else return '50%'
    },
    shadowStyle () {
      console.debug('*** Start *** shadowStyle')
      if (this.color.shadowType === 0) return 'drop-shadow(0px 0px 0px rgba(0,0,0,0.6))'
      else return 'drop-shadow(1px 1px 1px rgba(0,0,0,0.6))'
    },
    autoColor (c) {
      var color = hex2rgb(c)
      var cl = '#000'
      if ((color[0] * 0.299 + color[1] * 0.587 + color[2] * 0.114) < 206) {
        cl = '#FFF'
      }
      return cl
    },
    onFileChange (e) {
      console.debug('*** Start *** autoColor')
      console.error('e: ' + JSON.stringify(e))
      let files = e.target.files || e.dataTransfer.files
      this.filename = files[0].name
      let reader = new FileReader()
      reader.onload = (e) => {
        this.$store.dispatch('auth/setIconImage', {name: this.filename, data: e.target.result})
      }
      reader.readAsDataURL(files[0])
      console.debug('*** End *** autoColor')
    },
    getRequiredFlg (flg) {
      console.debug('*** Start *** getRequiredFlg')
      console.debug('flg: ' + flg)
      if (flg) return '必須'
      else return '任意'
    }
  }
}
</script>

<style scoped>
.tab-container {
  margin: 0;
  height: 100vh;
}
.flex{
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
}
.block-container {
  height: calc(100vh - 50px);
  //overflow-y: scroll;
  //overflow-x: hidden;
  padding: 16px;
  width: 100%;
  flex-flow: column nowrap;
}
.block-container::-webkit-scrollbar {
  //width: 10px;
  //height: 10px;
  //visibility: hidden;
}

.edit-field{
  padding: 16px;
}

h1 {
  font-weight: 700;
  font-size: 18px;
}
.blank {
  width: 150px;
}
.list-card {
  max-width: 30vw;
  min-height: 50vh;
  padding: 8px;
}
.inner-card {
  padding: 24px;
  margin: 8px;
  max-width: 30vw;
}
.add-box {
  margin-top: 16px;
  width: 65vw;
  height: auto;
  padding: 16px;
  line-height: 15px;
  border: solid thin #ccc;
  /* word-wrap: break-word; */
}
.custom-label {
  padding-left: 8px !important;
  padding-right: 16px !important;
}
.tabs-common-setting {
  margin-bottom: 8px;
  padding: 7px;
}
.tab-box-form {
  width: 100%; display: flex; padding: 8px;
  flex-wrap: wrap;
  max-width: 500px;
}
.tab-box-left {
  width: 40%; display: flex; justify-content: flex-start; align-items: center;
  border-right: solid 2px #ccc;
}
.tab-box-right {
  width: 60%; font-size: 13px; padding: 8px; justify-content: flex-start; display: flex;
  flex-wrap: wrap;
}
.dot-line {
  height: 10px;
  width: 100%;
  background-image: url('../../../assets/lp/dot.png');
  background-repeat: repeat-x;
  background-size: 10px;
  margin-top: 8px;
  margin-bottom: 8px;
}
</style>



// WEBPACK FOOTER //
// src/views/DashBoard/Setting/CommonSetting.vue